import { render, staticRenderFns } from "./insUser.vue?vue&type=template&id=27f72c40&"
import script from "./insUser.vue?vue&type=script&lang=js&"
export * from "./insUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports